export const isPreBookedAssignment = (assignment) => assignment?.status === 'Pre-Booked';

export const isAssignmentVisible = (assignment, ltoeWebAssignmentsPreBookingFlag) => {
    if (!assignment) return false;
    if (!ltoeWebAssignmentsPreBookingFlag && isPreBookedAssignment(assignment)) {
        return false;
    }
    return true;
};

export default { isAssignmentVisible, isPreBookedAssignment };
